<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar" style="cursor:pointer">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="col-sm-12">
                    <div class="row dblock">
                        <div class="row">
                            <div class="col-md-12 print-media">
                                <vs-breadcrumb align="left" :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Tematic Area Report',
                      active: true
                    }
                  ]"></vs-breadcrumb>
                                <div class="heading mt-3">
                                    <h3 class="text-secondary">Aggregate Analytical Report</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- -->
                    <template>
                        <div class="form-row print-media">
                            <div class="col-sm-12">
                                <b-card style="border: 1px dotted #07a7e14f;">
                                    <div class="row">
                                        <div class="col-sm-8">
                                            <label style="font-weight:700;" for="first">Select Thematic Area
                                            </label>
                                            <multiselect v-model="selectedArea" :options="thematicAreasLoad" label="name" placeholder="Search or Select Thematic Area" :multiple="false" track-by="id"></multiselect>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label style="font-weight:700;" for="first">Date Range
                                                </label>

                                                <flat-pickr class="form-control" style="background: #fff;opacity:1" placeholder="Start date Range" v-model="dateRange" :config="dateOptions"></flat-pickr>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 text-right mt-2">
                                            <!-- Get Report button -->
                                            <b-button class="download-btn" variant="primary" @click="getReport" :disabled="!selectedArea || !startDate || !endDate">
                                                Get Report
                                            </b-button>
                                        </div>
                                    </div>
                                </b-card>
                            </div>
                        </div>
                    </template>
                    <!-- -->
                    <template v-if="showGraph == true">
                        <div class="row mt-1">
                            <div class="col-md-4">
                                <div class="print_logo " style="display:none;" slot="header">
                                    <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
                                </div>
                            </div>
                            <div class="col-md-4 mt-6">
                                <h5 class="text-blue print_logo" style="display:none;margin-top: 20px;">
                                    Thematic Analysis Report
                                </h5>
                            </div>
                            <div class="col-md-4">
                                <h6 class="print_logo mt-1" style="display:none;text-align:justify;  padding-left: 45px">
                                    Country Office Pakistan<br />Monitoring & Evaluation Unit
                                </h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <h6 class="text-blue print-title">
                                    Thematic Event Information
                                </h6>
                            </div>
                            <div class="col-lg-6">
                                <button class="btn btn-primary text-uppercase btn-report float-right ml-3" @click="PrintTrainingDetails">
                                    Print Aggregate Analysis Report
                                </button>
                            </div>
                        </div>

                        <div class="row p-lg-3">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <template v-if="thematicReport.length > 0">
                                            <th scope="col">Tematic Area</th>
                                            <td>
                                                {{ selectedArea.name }}
                                            </td>
                                            <th scope="col">Country</th>

                                            <td>
                                                {{ thematicReport[0].training.district.province.country.title  || '' }}
                                            </td>
                                            <th scope="col">No of Training</th>
                                            <td @click="openModal" class="pointer-cursor">
                                                {{ thematicReport.length }}
                                            </td>
                                        </template>
                                        <template v-else>
                                            <th scope="col">Tematic Area</th>
                                            <td>No Selected</td>
                                            <th scope="col">Country</th>
                                            <td>No added</td>
                                        </template>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div class="row p-lg-3">
                            <!-- --------------------------  -->
                            <div class="col-lg-4 col-md-4" style="padding-left:0.5px">
                                <table class="table table-bordered mb-1">
                                    <thead>
                                        <tr>
                                            <th style="text-align:center">Gender Segregation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="text-align:center">
                                                <div id="pie-male-female" style="min-height:170px;height: 170px; width: 100%;margin-bottom:0px"></div>
                                                <b>Males: </b>{{ maleCount  }} <b>Females: </b>{{ femaleCount  }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- --------------------------  -->
                        <div class="row p-lg-3">
                            <div class="col-lg-4 col-md-4 line-bordered text-center print_screen2">
                                <h6 class="mt-3 text-dark" style="">
                                    Average Actual knowledge change
                                </h6>
                                <div id="average-actual-knowledge-change" style="height: 300px; width: 100%;" class="print-actual-graph"></div>
                            </div>
                            <!-- --------------------------  -->
                            <div class="col-lg-4 col-md-4 line-bordered text-center" v-for="(question,qindex) in commonQuestions" :key="qindex">
                                <div :id="'two_options_graph' + question.id">
                                    <h6 class="mt-3 text-dark">
                                        {{ question.title }} {{question.id}}
                                    </h6>

                                    <div :id="'two-options' + question.id" style="height: 300px; width: 100%;"></div>
                                </div>

                                <div :id="'three_options_graph' + question.id">
                                    <h6 class="mt-3 text-dark">
                                        {{ question.title }}
                                    </h6>
                                    <div :id="'three-options' + question.id" style="height: 200px; width: 100%;"></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12 line-bordered text-center print_screen2 line-break " v-for="(question,qindex) in commonQuestions" :key="qindex">
                                <div :id="'five_options_graph' + question.id">
                                    <h6 class="text-dark" style="font-size:14px">
                                        {{ question.title}}
                                    </h6>
                                    <div :id="'five-options' + question.id" style="height: 400px; width: 100%;"></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12 line-bordered text-center print_screen2 line-break" v-for="(question,qindex) in commonQuestions" :key="qindex">
                                <div :id="'four_options_graph' + question.id">
                                    <h6 class="text-dark" style="font-size:14px">
                                        {{ question.title}}
                                    </h6>
                                    <div :id="'four-options' + question.id" style="height: 130px; width: 100%;"></div>
                                </div>
                            </div>
                            <!-- --------------------------  -->
                            <div class="col-lg-12 col-md-12 line-bordered text-center print_screen2 line-break chart-container" v-for="(questionp,qindex) in questionsPArray" :key="'sp_'+qindex">
                                <div :id="'four_options_graphp' + questionp.id">
                                    <hr />
                                    <h6 class="text-dark" style="font-size:14px">
                                        {{ questionp.title }}
                                    </h6>
                                    <div :id="'four-optionsp' + questionp.id" style="height: 130px; width: 100%;"></div>
                                    <hr />
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4 line-bordered text-center print_screen" v-for="(questionp,qindex) in questionsPArray" :key="'sp_ytuyt'+qindex">
                                <div :id="'two_options_graphp' + questionp.id">
                                    <h6 class="mt-3 text-dark">{{ questionp.title }}</h6>

                                    <div :id="'two-optionsp' + questionp.id" style="height: 300px; width: 100%;"></div>
                                </div>
                                <!-- exercise-during-training -->
                                <div :id="'three_options_graphp' + questionp.id">
                                    <h6 class="mt-1 text-dark">{{ questionp.title }}</h6>
                                    <div :id="'three-optionsp' + questionp.id" style="height: 350px; width: 100%;"></div>
                                </div>
                                <div :id="'five_options_graphp' + questionp.id">
                                    <hr />
                                    <h6 class="mt-3 text-dark">{{ questionp.title }}</h6>
                                    <div :id="'five-optionsp' + questionp.id" style="height: 480px; margin-bottom:0px;width: 100%;"></div>
                                    <hr />
                                </div>
                            </div>
                            <!-- --------------------------  -->
                        </div>

                        <!-- Modal -->
                        <div class="modal2" v-if="isModalOpen">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <!-- Modal Header -->
                                    <div class="modal-header">
                                        <h4 class="modal-title">Trainings</h4>
                                        <button type="button" class="close" @click="closeModal">
                                            &times;
                                        </button>
                                    </div>

                                    <!-- Modal body -->
                                    <div class="modal-body">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Trainings</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in thematicReport" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ item.training.title }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Modal close -->
                    </template>
                    <!-- -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Highcharts from "../../../../public/highcharts";
import $ from "jquery";


export default {
    data: () => ({
        isSidebar: false,
        thematicAreasLoad: [],
        selectedArea: null,
        areaId: "",
        thematicReport: [],
        basepath: localStorage.getItem("BASE_PATH"),
        maleCount: 0,
        femaleCount: 0,
        prePercent: 0,
        postPercent: 0,
        commonQuestions: [],
        questionsPArray: [],
        counterA: 0,
        labelArray: [],
        labelPArray: [],
        selectedOptions: [],
        selectedPOptions: [],
        isModalOpen: false,
        showGraph: false,
        dateRange: [],
        dateOptions: {
            wrap: true,
            weekNumbers: true,
            mode: "range",
            dateFormat: "d-m-Y"
        },
        startDate: '',
        endDate: '',
    }),
    mounted() {
        axios.defaults.headers["Authorization"] = localStorage.getItem("token");
        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/thematics/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.thematicAreasLoad = response.data;
            });
    },
    methods: {
        openModal() {
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        totalMaleCount() {
            this.maleCount = this.thematicReport.reduce((total, item) => total + item.genderCounts.maleCount, 0);
        },
        totalFemaleCount() {
            this.femaleCount = this.thematicReport.reduce((total, item) => total + item.genderCounts.femaleCount, 0);
        },
        totalPrePercentage() {
            this.prePercent = this.thematicReport.reduce((total, item) => total + item.knowledgebase.prePercentage, 0)
        },
        totalPostPercentage() {
            this.postPercent = this.thematicReport.reduce((total, item) => total + item.knowledgebase.postPercentage, 0)
        },
        getReport() {
            axios.defaults.headers['Authorization'] = localStorage.getItem('token')
            this.openLoading();
            this.showGraph = true;
            axios
                .post(localStorage.getItem("BASE_PATH") + "/report/getTrainingViaThematicId", {
                    thematicId: this.areaId.toString(),
                    startDate: this.startDate,
                    endDate: this.endDate,
                })
                .then(response => {
                    if (response.data == "") {
                        this.closeLoading();
                        this.$toasted.global.errorMsg('There is no data');
                    }
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.thematicReport = response.data;
                    this.totalMaleCount();
                    this.totalFemaleCount();
                    this.genderChart();
                    this.totalPrePercentage();
                    this.totalPostPercentage();
                    this.assesmentChart();
                    this.showReportAllQuestions();
                    this.showReportPostQuestions()
                })

        },
        genderChart: function genderChart() {
            Highcharts.chart("pie-male-female", {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: "pie",
                },
                title: {
                    text: "Browser market shares at a specific website, 2014",
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.0f}%</b>",
                },
                accessibility: {
                    point: {
                        valueSuffix: "%",
                    },
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",

                        dataLabels: {
                            enabled: true,
                            format: "<b>{point.name}</b><br>{point.percentage:.0f} %",
                            distance: -35,
                            filter: {
                                property: "percentage",
                                operator: ">",
                                value: 4,
                            },
                        },
                    },
                },
                series: [{
                    name: "Share",
                    data: [{
                            name: "Males",
                            y: this.maleCount,
                            color: "#4774B8"
                        },
                        {
                            name: "Females",
                            y: this.femaleCount,
                            color: "#EA7D3A"
                        },
                    ],
                }, ],
            });
        },
        assesmentChart() {

            Highcharts.chart("average-actual-knowledge-change", {
                chart: {
                    type: "column",
                },
                title: {
                    text: "Browser market shares. January, 2018",
                },

                accessibility: {
                    announceNewData: {
                        enabled: true,
                    },
                },
                xAxis: {
                    type: "category",
                },
                yAxis: {},
                legend: {
                    enabled: false,
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: "{point.y:.1f}%",

                        }
                    },
                },

                tooltip: {

                    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
                },

                series: [{

                    colorByPoint: true,
                    data: [{
                            name: "Pre",
                            y: this.prePercent,
                            color: "#80ff80"
                        },
                        {
                            name: "Post",
                            y: this.postPercent,
                            color: "#63b94b",
                        },
                    ],
                }, ],
            });
        },
        showReportAllQuestions() {

            let commonQuestions = []
            for (let i = 0; i < this.thematicReport.length; i++) {
                const currentQuestions = this.thematicReport[i].allQuestions.questions;
                if (i === 0) {
                    commonQuestions = currentQuestions.map(question => question.id);
                } else {
                    commonQuestions = commonQuestions.filter(questionId => currentQuestions.some(question => question.id === questionId));
                }
            }

            const commonQuestionsData = commonQuestions.map(questionId => {
                const question = this.thematicReport.find(data => data.allQuestions.questions.some(q => q.id === questionId)).allQuestions.questions.find(q => q.id === questionId);
                return question;
            });

            this.commonQuestions = commonQuestionsData
            const options = this.thematicReport[0].allQuestions.options

            const questionBanksById = {};
            options.forEach(questionBankSet => {
                questionBankSet.forEach(question => {
                    if (!(question.questionBank_id in questionBanksById)) {
                        questionBanksById[question.questionBank_id] = [];
                    }
                    const isUnique = !questionBanksById[question.questionBank_id].some(q => q.id === question.id);
                    if (isUnique) {
                        questionBanksById[question.questionBank_id].push(question);
                    }
                });
            });
            // Convert the object into an array of arrays
            const questionBanksArray = Object.values(questionBanksById);

            this.openLoading();
            setTimeout(() => {
                commonQuestionsData.forEach((element) => {
                    questionBanksArray.forEach((opt) => {
                        this.labelArray = [];
                        this.selectedOptions = [];
                        opt.forEach((oneopt, optindex) => {
                            if (oneopt.questionBank_id == element.id) {
                                this.selectedOptions.push(0);
                                this.thematicReport.forEach((report) => {
                                    report.allQuestions.preAssessments.forEach((asses) => {
                                        if (asses.option_id == oneopt.id) {
                                            this.selectedOptions[optindex] =
                                                this.selectedOptions[optindex] + 1;
                                        }
                                    });
                                })

                                if (opt.length == optindex + 1) {
                                    if (oneopt && oneopt.title) {
                                        this.labelArray.push(oneopt.title);
                                    } else {
                                        this.labelArray.push(oneopt);
                                    }
                                    if (this.labelArray && this.labelArray.length == 2) {
                                        $("#three_options_graph" + element.id).hide();
                                        $("#four_options_graph" + element.id).hide();
                                        $("#four_options_graph" + element.id).parent().hide();
                                        $("#five_options_graph" + element.id).hide();
                                        $("#five_options_graph" + element.id).parent().hide();

                                        Highcharts.chart("two-options" + element.id, {
                                            chart: {
                                                plotBackgroundColor: null,
                                                plotBorderWidth: null,
                                                plotShadow: false,
                                                type: "pie",
                                            },
                                            title: {
                                                text: "Browser market shares in January, 2018",
                                            },
                                            tooltip: {
                                                pointFormat: "{series.name}: <b>{point.percentage:.2f}%</b>",
                                            },
                                            plotOptions: {
                                                pie: {
                                                    allowPointSelect: true,
                                                    cursor: "pointer",
                                                    dataLabels: {

                                                        connectNulls: true,
                                                        enabled: true,
                                                        formatter: function () {
                                                            if (this.y != 0) {
                                                                return this.point.percentage.toFixed(1) + '%'
                                                            }
                                                        },

                                                    },
                                                    showInLegend: true,
                                                },
                                            },
                                            series: [{
                                                name: "Answer",
                                                colorByPoint: true,
                                                data: [{
                                                        name: this.labelArray[0],
                                                        y: this.selectedOptions[0],
                                                        color: "#71da71",
                                                    },
                                                    {
                                                        name: this.labelArray[1],
                                                        y: this.selectedOptions[1],
                                                        color: "#ff5c33",
                                                    },
                                                ],
                                            }, ],
                                        });
                                    } else if (
                                        this.labelArray &&
                                        this.labelArray.length == 4
                                    ) {
                                        $("#three_options_graph" + element.id).hide();
                                        $("#two_options_graph" + element.id).hide();
                                        $("#five_options_graph" + element.id).hide();
                                        $("#five_options_graph" + element.id).parent().hide();
                                        $("#five_options_graph" + element.id).parent().removeClass('print_screen');
                                        $("#two_options_graph" + element.id).parent().hide();
                                        $("#two_options_graph" + element.id).parent().removeClass('print_screen');
                                        $("#three_options_graph" + element.id).parent().hide();
                                        $("#three_options_graph" + element.id).parent().removeClass('print_screen');
                                        $("#five_options_graphp" + element.id).parent().hide();
                                        $("#five_options_graphp" + element.id).parent().removeClass('print_screen');
                                        $("#two_options_graphp" + element.id).parent().hide();
                                        $("#two_options_graphp" + element.id).parent().removeClass('print_screen');
                                        $("#three_options_graphp" + element.id).parent().hide();
                                        $("#three_options_graphp" + element.id).parent().removeClass('print_screen');
                                        Highcharts.chart("four-options" + element.id, {
                                            chart: {
                                                type: "bar",
                                            },
                                            title: {
                                                text: "Stacked bar chart",
                                            },
                                            xAxis: {
                                                categories: [""],
                                            },
                                            yAxis: {
                                                min: 0,
                                            },
                                            legend: {
                                                reversed: true,
                                                align: "center",
                                                verticalAlign: "bottom",
                                                itemStyle: {
                                                    fontSize: '12px',
                                                }
                                            },
                                            plotOptions: {
                                                series: {
                                                    stacking: "percent",
                                                    dataLabels: {
                                                        enabled: true,
                                                        formatter: function () {
                                                            if (this.y != 0) {
                                                                return this.point.percentage.toFixed(1) + '%'
                                                            }
                                                        },
                                                    }
                                                },
                                            },
                                            series: [{
                                                    name: this.labelArray[0],
                                                    data: [this.selectedOptions[0]],
                                                    color: "#4dd2ff"

                                                },
                                                {
                                                    name: this.labelArray[1],
                                                    data: [this.selectedOptions[1]],
                                                    color: "#71da71"
                                                },
                                                {
                                                    name: this.labelArray[2],

                                                    data: [this.selectedOptions[2]],
                                                    color: "#ffdb4d"

                                                },
                                                {
                                                    name: this.labelArray[3],
                                                    data: [this.selectedOptions[3]],
                                                    color: "#ff5c33"

                                                },
                                            ],
                                        });

                                    } else if (
                                        this.labelArray &&
                                        this.labelArray.length == 3
                                    ) {
                                        $("#four_options_graph" + element.id).hide();
                                        $("#four_options_graph" + element.id).parent().hide();

                                        $("#two_options_graph" + element.id).hide();
                                        $("#five_options_graph" + element.id).hide();

                                        Highcharts.chart("three-options" + element.id, {
                                            chart: {
                                                type: "column",
                                            },
                                            title: {
                                                text: "Stacked column chart",
                                            },
                                            xAxis: {
                                                // categories: ["Testing"],
                                            },
                                            yAxis: {
                                                min: 0,
                                                stackLabels: {
                                                    enabled: false,
                                                    style: {
                                                        fontWeight: "bold",
                                                        color:
                                                            // theme
                                                            (Highcharts.defaultOptions.title.style &&
                                                                Highcharts.defaultOptions.title.style
                                                                .color) ||
                                                            "gray",
                                                    },
                                                },
                                            },
                                            legend: {
                                                align: "right",
                                                x: -30,
                                                verticalAlign: "bottom",
                                                y: 15,
                                                floating: false,
                                                backgroundColor: Highcharts.defaultOptions.legend
                                                    .backgroundColor || "white",
                                                borderColor: "#CCC",
                                                borderWidth: 1,
                                                shadow: false,
                                                itemStyle: {
                                                    fontSize: '10px',

                                                }
                                            },
                                            tooltip: {
                                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                                                shared: true,
                                            },
                                            plotOptions: {
                                                column: {
                                                    stacking: "percent",
                                                    dataLabels: {
                                                        enabled: true,
                                                        // format:'{point.percentage:.2f} %'
                                                        formatter: function () {
                                                            if (this.y != 0) {
                                                                return this.point.percentage.toFixed(1) + '%'
                                                            }
                                                        },
                                                    }
                                                },
                                            },
                                            series: [{
                                                    name: this.labelArray[0],
                                                    data: [this.selectedOptions[0]],
                                                    color: "#71da71",
                                                },
                                                {
                                                    name: this.labelArray[1],
                                                    data: [this.selectedOptions[1]],
                                                    color: "#ffd633",
                                                },
                                                {
                                                    name: this.labelArray[2],
                                                    data: [this.selectedOptions[2]],
                                                    color: "#0099cc",

                                                },
                                            ],
                                        });
                                    } else if (this.labelArray &&
                                        this.labelArray.length == 5) {
                                        $("#two_options_graph" + element.id).hide();
                                        $("#three_options_graph" + element.id).hide();
                                        $("#four_options_graph" + element.id).hide();
                                        $("#four_options_graph" + element.id).parent().hide();

                                        Highcharts.chart("five-options" + element.id, {
                                            chart: {
                                                type: 'bar'
                                            },
                                            title: {
                                                text: 'Bar Race Chart'
                                            },
                                            xAxis: {
                                                categories: [this.labelArray[4], this.labelArray[3], this.labelArray[2], this.labelArray[1], this.labelArray[0]]
                                            },
                                            yAxis: {
                                                min: 0,
                                                title: {
                                                    text: 'Values'
                                                }
                                            },

                                            legend: {

                                                align: "center",
                                                verticalAlign: "bottom",
                                                itemStyle: {
                                                    fontSize: '12px',
                                                }
                                            },
                                            plotOptions: {
                                                bar: {
                                                    dataLabels: {
                                                        enabled: true,
                                                        formatter: function () {
                                                            var total = this.series.data.reduce((acc, curr) => acc + curr.y, 0);
                                                            var percentage = (this.y / total) * 100;
                                                            return percentage.toFixed(1) + '%';
                                                        }
                                                    }
                                                }
                                            },

                                            series: [{

                                                data: [{
                                                        name: this.labelArray[4],
                                                        y: this.selectedOptions[4],
                                                        color: "#218FCE",
                                                        showInLegend: true

                                                    },
                                                    {
                                                        name: this.labelArray[3],
                                                        y: this.selectedOptions[3],
                                                        color: "#6AAA4A",
                                                        showInLegend: true

                                                    },
                                                    {
                                                        name: this.labelArray[2],
                                                        y: this.selectedOptions[2],
                                                        color: "#FEC447",
                                                        showInLegend: true
                                                    },
                                                    {
                                                        name: this.labelArray[1],
                                                        y: this.selectedOptions[1],
                                                        color: "#EF522F",
                                                        showInLegend: true

                                                    },
                                                    {
                                                        name: this.labelArray[0],
                                                        y: this.selectedOptions[0],
                                                        color: "#D1324E",
                                                        showInLegend: true

                                                    }
                                                ]
                                            }]

                                        });

                                        // .......
                                    }
                                } else {
                                    this.labelArray.push(oneopt.title);
                                }
                            }
                            this.counterA++;
                        });

                    });
                });
                this.closeLoading();
            }, 10000);

        },
        showReportPostQuestions() {

            const commonQuestionsData = this.thematicReport[0].standardPostQuestions.questions.slice(0, -2)
            this.questionsPArray = commonQuestionsData;
            const options = this.thematicReport[0].standardPostQuestions.options

            const optionsById = {};
            options.forEach(questionBankSet => {
                questionBankSet.forEach(question => {
                    if (!(question.questionBank_id in optionsById)) {
                        optionsById[question.questionBank_id] = [];
                    }
                    const isUnique = !optionsById[question.questionBank_id].some(q => q.id === question.id);
                    if (isUnique) {
                        optionsById[question.questionBank_id].push(question);
                    }
                });
            });

            const optionBanksArray = Object.values(optionsById);
            //.................
            this.openLoading();
            setTimeout(() => {
                commonQuestionsData.forEach((element) => {
                    optionBanksArray.forEach((opt) => {
                        this.labelPArray = [];
                        this.selectedPOptions = [];
                        opt.forEach((oneopt, optindex) => {
                            if (oneopt.questionBank_id == element.id) {
                                this.selectedPOptions.push(0);
                                this.thematicReport.forEach((report) => {
                                    if (report.standardPostQuestions.preassessment != "") {
                                        report.standardPostQuestions.preassessment.forEach((asses) => {
                                            if (asses.option_id == oneopt.id) {
                                                this.selectedPOptions[optindex] =
                                                    this.selectedPOptions[optindex] + 1;
                                            }
                                        });
                                    }
                                })

                                if (opt.length == optindex + 1) {
                                    if (oneopt && oneopt.title) {
                                        this.labelPArray.push(oneopt.title);
                                    } else {
                                        this.labelPArray.push(oneopt);
                                    }

                                    if (this.labelPArray && this.labelPArray.length == 2) {
                                        $("#three_options_graphp" + element.id).hide();
                                        $("#four_options_graphp" + element.id).hide();
                                        // $("#four_options_graphp" + element.id).parent().hide();
                                        $("#five_options_graphp" + element.id).hide();
                                        Highcharts.chart("two-optionsp" + element.id, {
                                            chart: {
                                                plotBackgroundColor: null,
                                                plotBorderWidth: null,
                                                plotShadow: false,
                                                type: "pie",
                                            },
                                            title: {
                                                text: "Browser market shares in January, 2018",
                                            },
                                            tooltip: {
                                                pointFormat: "{series.name}: <b>{point.percentage:.2f}%</b>",
                                            },
                                            plotOptions: {
                                                pie: {
                                                    allowPointSelect: true,
                                                    cursor: "pointer",
                                                    dataLabels: {
                                                        enabled: false,
                                                        formatter: function () {
                                                            if (this.y != 0) {
                                                                return this.point.percentage.toFixed(1) + '%'
                                                            }
                                                        },

                                                        //  format:'{point.percentage:.2f} %'
                                                    },
                                                    showInLegend: true,
                                                },
                                            },
                                            series: [{
                                                name: "Answer",
                                                colorByPoint: true,
                                                data: [{
                                                        name: this.labelPArray[0],
                                                        y: this.selectedPOptions[0],
                                                        color: "#71da71",
                                                    },
                                                    {
                                                        name: this.labelPArray[1],
                                                        y: this.selectedPOptions[1],
                                                        color: "#ff5c33",
                                                    },
                                                ],
                                            }, ],
                                        });
                                    } else if (
                                        this.labelPArray &&
                                        this.labelPArray.length == 4
                                    ) {
                                        $("#three_options_graphp" + element.id).hide();
                                        $("#two_options_graphp" + element.id).hide();
                                        $("#five_options_graphp" + element.id).hide();
                                        // $("#five_options_graphp" + element.id).parent().hide();
                                        Highcharts.chart("four-optionsp" + element.id, {
                                            chart: {
                                                type: "bar",
                                            },
                                            title: {
                                                text: "Stacked bar chart",
                                            },
                                            xAxis: {
                                                categories: [""],
                                            },
                                            yAxis: {
                                                min: 0,
                                            },
                                            legend: {
                                                reversed: true,
                                                align: "center",
                                                verticalAlign: "bottom",
                                                itemStyle: {
                                                    fontSize: '12px',
                                                }
                                            },
                                            plotOptions: {
                                                series: {
                                                    stacking: "percent",
                                                    dataLabels: {
                                                        enabled: true,
                                                        formatter: function () {
                                                            if (this.y != 0) {
                                                                return this.point.percentage.toFixed(1) + '%'
                                                            }
                                                        },

                                                        //  format:'{point.percentage:.2f} %'
                                                    }
                                                },
                                            },
                                            series: [{
                                                    name: this.labelPArray[0],
                                                    data: [this.selectedPOptions[0]],
                                                    color: "#4dd2ff"
                                                },
                                                {
                                                    name: this.labelPArray[1],
                                                    data: [this.selectedPOptions[1]],
                                                    color: "#71da71"
                                                },
                                                {
                                                    name: this.labelPArray[2],
                                                    data: [this.selectedPOptions[2]],
                                                    color: "#ffdb4d"
                                                },
                                                {
                                                    name: this.labelPArray[3],
                                                    data: [this.selectedPOptions[3]],
                                                    color: "#ff5c33"
                                                },
                                            ],
                                        });
                                    } else if (
                                        this.labelPArray &&
                                        this.labelPArray.length == 3
                                    ) {
                                        $("#four_options_graphp" + element.id).hide();
                                        $("#two_options_graphp" + element.id).hide();
                                        $("#five_options_graphp" + element.id).hide();
                                        $("#four_options_graphp" + element.id).parent().hide();
                                        Highcharts.chart("three-optionsp" + element.id, {
                                            chart: {
                                                type: "column",
                                            },
                                            title: {
                                                text: "Stacked column chart",
                                            },
                                            xAxis: {
                                                // categories: ["Practicals"],
                                            },
                                            yAxis: {
                                                min: 0,
                                                stackLabels: {
                                                    enabled: false,
                                                    style: {
                                                        fontWeight: "bold",
                                                        color:
                                                            // theme
                                                            (Highcharts.defaultOptions.title.style &&
                                                                Highcharts.defaultOptions.title.style
                                                                .color) ||
                                                            "gray",
                                                    },
                                                },
                                            },
                                            legend: {
                                                // align: "left",
                                                // x: -30,
                                                verticalAlign: "bottom",
                                                // y: 15,
                                                floating: false,
                                                backgroundColor: Highcharts.defaultOptions.legend
                                                    .backgroundColor || "white",
                                                borderColor: "#CCC",
                                                borderWidth: 1,
                                                shadow: false,
                                                itemStyle: {
                                                    fontSize: '7px',
                                                    fontWeight: '1000',
                                                },

                                            },
                                            tooltip: {
                                                pointFormat: '<span class="inline" style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                                shared: true,
                                            },
                                            plotOptions: {

                                                column: {
                                                    stacking: "percent",
                                                    dataLabels: {
                                                        enabled: true,
                                                        formatter: function () {
                                                            if (this.y != 0) {
                                                                return this.point.percentage.toFixed(1) + '%'
                                                            }
                                                        },
                                                    },
                                                },
                                            },
                                            series: [{
                                                    name: this.labelPArray[0],
                                                    data: [this.selectedPOptions[0]],
                                                    color: "#71da71",

                                                },
                                                {
                                                    name: this.labelPArray[1],
                                                    data: [this.selectedPOptions[1]],
                                                    color: "#fec447",
                                                },
                                                {
                                                    name: this.labelPArray[2],
                                                    data: [this.selectedPOptions[2]],
                                                    color: "#218fce",
                                                }

                                            ]
                                        });
                                    } else if (this.labelPArray &&
                                        this.labelPArray.length == 5) {
                                        $("#two_options_graphp" + element.id).hide();
                                        $("#three_options_graphp" + element.id).hide();
                                        // $("#four_options_graphp" + element.id).hide();parent().hide();
                                        $("#four_options_graphp" + element.id).parent().hide();
                                        Highcharts.chart("five-optionsp" + element.id, {
                                            chart: {
                                                type: "column",
                                            },
                                            title: {
                                                text: "Stacked column chart",
                                            },
                                            xAxis: {

                                            },
                                            yAxis: {
                                                min: 0,
                                                stackLabels: {
                                                    enabled: false,
                                                    style: {
                                                        fontWeight: "bold",
                                                        color:
                                                            // theme
                                                            (Highcharts.defaultOptions.title.style &&
                                                                Highcharts.defaultOptions.title.style
                                                                .color) ||
                                                            "gray",
                                                    },
                                                },
                                            },
                                            legend: {
                                                align: "right",
                                                x: -30,
                                                verticalAlign: "bottom",
                                                y: 15,
                                                floating: false,
                                                backgroundColor: Highcharts.defaultOptions.legend
                                                    .backgroundColor || "white",
                                                borderColor: "#CCC",
                                                borderWidth: 1,
                                                shadow: false,
                                                itemStyle: {
                                                    fontSize: '12px',
                                                }
                                            },
                                            tooltip: {
                                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.0f}%</b> ({point.percentage:.0f}%)<br/>',
                                                shared: true,
                                            },
                                            plotOptions: {
                                                column: {
                                                    stacking: "percent",
                                                    dataLabels: {
                                                        enabled: true,

                                                        formatter: function () {
                                                            if (this.y != 0) {
                                                                return this.point.percentage.toFixed(1) + '%'
                                                            }
                                                        },

                                                    },
                                                },
                                            },
                                            series: [{
                                                    name: this.labelPArray[0],
                                                    data: [this.selectedPOptions[0]],
                                                    color: "#D1324E"
                                                },
                                                {
                                                    name: this.labelPArray[1],
                                                    data: [this.selectedPOptions[1]],
                                                    color: "#EF522F"
                                                },
                                                {
                                                    name: this.labelPArray[2],
                                                    data: [this.selectedPOptions[2]],
                                                    color: "#FEC447"
                                                },
                                                {
                                                    name: this.labelPArray[3],
                                                    data: [this.selectedPOptions[3]],
                                                    color: "#6AAA4A",

                                                },
                                                {
                                                    name: this.labelPArray[4],
                                                    data: [this.selectedPOptions[4]],
                                                    color: "#218FCE",

                                                },
                                            ],
                                        });
                                    }
                                } else {
                                    this.labelPArray.push(oneopt.title);
                                }
                            }
                            this.counterA++;
                        });

                    });
                });
                this.closeLoading();
            }, 10000);
            //.................

        },
        PrintTrainingDetails: function () {
            window.print();
        },

    },

    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        Multiselect,
        flatPickr,
    },
    watch: {
        selectedArea(newValue) {
            this.areaId = newValue.id
        },
        dateRange(date) {
            this.startDate = date.split("to")[0].trim();
            this.endDate = date.split("to")[1].trim();

        },
    },

};
</script>

<style scoped>
.myNavbar {
    color: rgb(255, 255, 255);
}

.line-bordered {
    border-top: 2px solid #6c757d;
    border-bottom: 2px solid #6c757d;
    border-left: 1px solid #6c757d;
    border-right: 1px solid #6c757d;
}

.print_screen2 {
    margin-top: 0px;
    margin-bottom: 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.btn-report {
    background-color: #6488d2 !important;
    border-radius: 0px !important;
    padding: 3px 30px !important;
}

.pointer-cursor {
    cursor: pointer;

}

.modal2 {

    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
}

/* Modal content */
.modal-content {
    background-color: #fefefe;
    margin: 1% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 100%;
    /* Could be more or less, depending on screen size */
}

.modal-dialog {
    max-width: 600px
}

/* Close button */
.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

@media print {

    @page {
        counter-increment: page
    }

    @page: first {
        counter-reset: page 9
    }

    #pageCounter {
        content: counter(page)
    }

    #page_one_count {
        display: block;
        position: absolute;
        top: 98%;
        right: 2%;
    }

    #page_two_count {
        display: block;
    }

    #page-content-wrapper {
        padding-right: -15px;
        padding-left: -15px;
         overflow: visible !important;
        scrollbar-width: 12px;
        height: auto !important;
    }

    .print_logo {
        display: block !important;
        text-align: justify;
    }

    /* Training title */
    .print-trainin-title {
        font-size: 20px;
    }

    .print-actual {
        height: 400px;
        width: 100px;
        margin-bottom: 500px;

    }

    .print-actual-graph {
        height: 170px;
        width: 100px;
    }

    .print-actual-size {
        width: 100%;
        height: 300px;
    }

    .print_screen2 {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .print_screen {
        margin-top: 35px;
    }

    .print-margin {
        margin-bottom: 100px;

    }

    .average_actual {
        margin-top: 0px;
    }

    .btn-report {
        display: none;
    }

    .print-media {
        display: none;
    }

    .col-md-4 {
        flex: 1;
        /* Ensure each column takes up equal width */
        max-width: 50%;
        /* Ensure each column remains a third of the row width */
    }

    .col-md-6 {
        flex: 1;
        /* Ensure each column takes up equal width */
        max-width: 50%;
        /* Ensure each column remains a third of the row width */
    }

    .print-title {
        font-size: 15px;
    }

    .print-training-title {
        display: none;
    }

    footer {
        position: fixed;
        bottom: 0;
    }

    .chart-container {
        page-break-before: always;
    }

}

@media (max-width: 768px) {}
</style>
